<template>
    <div>
        <div class="kirstyn-credit">
            <img src="../assets/kirstyn-credit-small-square.png" class="image">
            <div class="credit-blurb">
                <p>
                This website is a labor of love designed, built, and deployed by Kirstyn Blandy, 
                a creative powerhouse with over 2 decades of experience composing, performing, and collaborating with other artists.     
                </p>
            </div>
            
        </div>
        <div class="social-media-bar footer-links">
                    <a href="https://isolationtankensemble1.bandcamp.com/album/heliography" target="blank"><img src="../assets/icon-bandcamp2.png" class="nav-item nav-icon"></a>
                    <a href="mailto:kirstyn.blandy@gmail.com"><img src="../assets/icon-contact.png" class="nav-item nav-icon"></a>
                    <a href="https://soundcloud.com/isolationtankensemble" target="blank"><img src="../assets/icon-soundcloud.png" class="nav-item nav-icon"></a>
                    <a href="https://www.instagram.com/isolationtankensemble/?hl=en" target="blank"><img src="../assets/icon-instagram.png" class="nav-item nav-icon"></a>
                    <a href="https://www.facebook.com/isolationtankensemble/" target="blank"><div class="fb-step-off nav-item nav-icon">f</div></a>
                    <a href="https://linktr.ee/isolationtankensemble" target="blank"><img src="../assets/lintree-logo.png" class="nav-item nav-icon"></a>
                </div>
        <div>
            <p>
                For inquiries regarding musical collaboration, art requests, or EPK and website consultations, please do not hesitate
                to contact us.  There is no greater joy than contributing to the delivery of artistic vision, and we would love to help.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteCredit',
}
</script>

<style scoped>


.image {
    width: 60%;
    align-self: center;
    border-radius: 50%;
    margin: 1em;
}
.kirstyn-credit {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* media queries */

@media only screen and (min-width: 600px) {
    .image {
        width: 60%;
    }
    .kirstyn-credit {
        flex-direction: row;
        height: 75%;
        margin-top: 2em;
    }
}

@media only screen and (min-width: 1000px) {
    .image {
        width: 50%;
    }
    .kirstyn-credit {
        flex-direction: row;
        height: 75%;
        margin-top: 2em;
    }
}

@media only screen and (min-width: 1400px) {
    .image {
        width: 40%;
    }
    .kirstyn-credit {
        flex-direction: row;
        height: 60%;
        margin-top: 2em;
    }
    .credit-blurb {
        margin-top: 4em;
    }
}


</style>